'use client';

import { usePromptTrigger } from '@/hooks/usePromptTrigger';

interface OwnerPromptTriggerProps {
  ownerSlug: string;
}

/**
 * Fires the prompt-counter increment for an owner page view. Deduped
 * by owner slug (same slug = same view). Renders nothing.
 *
 * No return-URL is passed: the owner surface fires the review prompt,
 * not the report one, so there's no subscription purchase to come back
 * from.
 */
export function OwnerPromptTrigger({ ownerSlug }: OwnerPromptTriggerProps) {
  usePromptTrigger('owner', ownerSlug);
  return null;
}
